import {
	List,
	ListItemButton,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { Check } from "lucide-react";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type Props<TValue extends string | number = string> = {
	options: FlatRowSelectOption<TValue>[];
	value: TValue | "";
	onSelect: (value: TValue) => void;
};

export const FlatRowSelectOptionList = <
	TValue extends string | number = string,
>({
	options,
	value,
	onSelect,
}: Props<TValue>) => {
	const theme = useTheme();

	return (
		<List disablePadding>
			{options.map((option) => {
				const isSelected = String(option.value) === String(value);
				return (
					<ListItemButton
						key={String(option.value)}
						onClick={() => onSelect(option.value)}
						sx={{
							px: 2,
							py: 1.4,
							borderBottom: theme.colors.border.flatRowDivider,
						}}
					>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-between"
							width="100%"
						>
							<Typography
								variant="deprecatedBody1"
								fontWeight={isSelected ? 600 : 400}
								color={
									isSelected
										? theme.palette.primary.main
										: theme.palette.deprecated.grey[900]
								}
							>
								{option.label}
							</Typography>
							{isSelected && (
								<Check size={18} color={theme.palette.primary.main} />
							)}
						</Stack>
					</ListItemButton>
				);
			})}
		</List>
	);
};
